import React, { useMemo } from 'react';

import GoogleMaps from '../../../../components/google-maps/GoogleMaps';
import { IMyCraneProps } from './my-crane-types';
import { MyCraneStyle } from './my-crane-style';

const MyCrane: React.FC<IMyCraneProps> = ({ coords, craneData: data, taxiCoords }) => {
  const myCraneLocation: [number, number] | undefined = useMemo(() => {
    if (!data) return undefined;
    return [+data.latitud, +data.longitud];
  }, [data]);

  return (
    <MyCraneStyle>
      <GoogleMaps coords={coords || undefined} myCrane={myCraneLocation} myTaxi={taxiCoords} showLocation />
    </MyCraneStyle>
  );
};

export default MyCrane;
